import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, signal, effect} from '@angular/core';

import {RegionService} from "@app/areas/auth/services/region.service";
import {SupportedRegion} from "@app/areas/auth/models/supported-region.interface";
import {IdentityUserRegion} from "@app/areas/users/models/identity-user.interface";

@Component({
  selector: 'app-region-selection',
  standalone: true,
  imports: [],
  templateUrl: './region-selection.component.html',
  styleUrls: ['./region-selection.component.scss']
})
export class RegionSelectionComponent implements OnChanges {
  /**
   * Allow a default non-selected region, indicating to the user that they need to make a selection
   */
  @Input() allowNoSelection = false
  @Input() selectedRegion: IdentityUserRegion | string | null = null;

  // Keep a primitive value bound to the <select> so it updates when the input changes.
  selectedRegionId$ = signal('')

  @Output() regionSelected = new EventEmitter<SupportedRegion>();

  constructor(public regionService: RegionService) {
    // effect(() => {
    //   const r = this.regionService.selectedRegion$()
    //   console.log('R', r)
    //   this.selectedRegionId$.set(r)
    // });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRegion']) {
      this.selectedRegionId$.set(this.toRegionId(this.selectedRegion))
      console.log('selectedRegionId', this.selectedRegionId$())
    }
  }

  private toRegionId(region: IdentityUserRegion | string | null): string {
    if (!region) return '';
    if (typeof region === 'string') return region;

    // Support common shapes defensively.
    const anyRegion: any = region;
    return (
      anyRegion.id ??
      anyRegion.region
    );
  }

  handleRegionChange($event): void {
    const value = String($event.target.value ?? '');
    this.selectedRegionId$.set(value)

    const r = this.regionService.supportedRegions.find(e => e.id === value);
    if (r) {
      this.regionSelected.emit(r);
    }
  }
}
